import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { ContactType, UserProfileResponse } from './contact-verification-service-types'
import { formatUserProfile } from './contact-verification-service-utils'
import { Account } from '@/domain/usecases'
import { UserInfo } from '@presentation/components/ui/form/contact-verification/contact-verification-btn'
import { formatCustomDateString } from '@/main/helpers'

export const contactVerificationService = {
  async updateAndFetchUserProfile(
    remoteAccountProfile: Account,
    profileData: Account.PersonalProfileModel
  ) {
    await remoteAccountProfile.updatePersonalProfile(profileData)
    return this.fetchUserProfile()
  },

  async updateContactInfo(userInfo: UserInfo) {
    const pathUrl = makeApiUrl('/v2/user/account/personal-data')

    const response = await httpServiceClient({
      method: 'patch',
      url: pathUrl,
      body: {
        personal_email: userInfo.personalEmail,
        phone: userInfo.phone,
        birthdate: formatCustomDateString(userInfo.birthdate, 'yyyy-mm-dd')
      }
    })

    return response.body
  },

  async fetchUserProfile() {
    const pathUrl = makeApiUrl('/v2/user/account/profile')

    const response = await httpServiceClient<UserProfileResponse>({
      method: 'get',
      url: pathUrl
    })

    const data = response?.body?.data
    if (!data) {
      throw new Error('User profile data not available')
    }

    return formatUserProfile(data as UserProfileResponse)
  },

  async sendCode(contactType: ContactType) {
    const pathUrl = makeApiUrl('/account/v2/verification-code/send')

    const response = await httpServiceClient({
      method: 'post',
      url: pathUrl,
      body: {
        contact_type: contactType
      }
    })

    return response.body
  },

  async verifyCode(code: string) {
    const pathUrl = makeApiUrl('/account/v2/verification-code/validate')

    await httpServiceClient({
      method: 'post',
      url: pathUrl,
      body: {
        verification_code: code
      }
    })
  }
}
